import { useTenantContext } from '../tenant-context/index.tsx';

export const useFirstActivationDateMs = (): number | null => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.firstActivationDateMs != null
		? tenantContext.firstActivationDateMs
		: null;
};
